import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["site", "quality"];
import { setParamIfDefined, setParamIfUndefined, toCanonicalUrlString, toUrl } from "../utils.js";
const skippedParams = new Set(["w", "h", "q", "fm", "url", "width", "height", "quality"]);
export const parse = url => {
  var _Number, _parsed$searchParams$, _Number2, _parsed$searchParams$2, _parsed$searchParams$3;
  const parsed = toUrl(url);
  const width = (_Number = Number((_parsed$searchParams$ = parsed.searchParams.get("w")) !== null && _parsed$searchParams$ !== void 0 ? _parsed$searchParams$ : parsed.searchParams.get("width"))) !== null && _Number !== void 0 ? _Number : undefined;
  const height = (_Number2 = Number((_parsed$searchParams$2 = parsed.searchParams.get("h")) !== null && _parsed$searchParams$2 !== void 0 ? _parsed$searchParams$2 : parsed.searchParams.get("height"))) !== null && _Number2 !== void 0 ? _Number2 : undefined;
  const quality = Number((_parsed$searchParams$3 = parsed.searchParams.get("q")) !== null && _parsed$searchParams$3 !== void 0 ? _parsed$searchParams$3 : parsed.searchParams.get("quality")) || undefined;
  const format = parsed.searchParams.get("fm") || undefined;
  const base = parsed.searchParams.get("url") || "";
  const params = {
    quality
  };
  parsed.searchParams.forEach((value, key) => {
    if (skippedParams.has(key)) {
      return;
    }
    params[key] = value;
  });
  parsed.search = "";
  return {
    base,
    width,
    height,
    format,
    params,
    cdn: "netlify"
  };
};
export const generate = _ref => {
  let {
      base,
      width,
      height,
      format,
      params: {
        site,
        quality
      } = {}
    } = _ref,
    params = _objectWithoutPropertiesLoose(_ref.params, _excluded);
  const url = toUrl("/.netlify/images", site);
  Object.entries(params).forEach(_ref2 => {
    let [key, value] = _ref2;
    return setParamIfDefined(url, key, value);
  });
  setParamIfDefined(url, "q", quality, true, true);
  setParamIfDefined(url, "w", width, true, true);
  setParamIfDefined(url, "h", height, true, true);
  setParamIfDefined(url, "fm", format);
  setParamIfUndefined(url, "fit", "cover");
  url.searchParams.set("url", base.toString());
  return toCanonicalUrlString(url);
};
export const transform = options => {
  var _options$cdnOptions, _options$cdnOptions$n;
  const url = toUrl(options.url);
  // If this is a Netlify image URL, we'll manipulate it rather than using it as the source image
  if (url.pathname.startsWith("/.netlify/images")) {
    const {
      params,
      base,
      format
    } = parse(url);
    return generate(Object.assign({
      base,
      format
    }, options, {
      params: Object.assign({}, params, {
        // If hostname is "n", we're dealing with a relative URL, so we don't need to set the site param
        site: url.hostname === "n" ? undefined : url.origin
      })
    }));
  }
  return generate(Object.assign({}, options, {
    base: options.url,
    params: {
      site: (_options$cdnOptions = options.cdnOptions) === null || _options$cdnOptions === void 0 ? void 0 : (_options$cdnOptions$n = _options$cdnOptions.netlify) === null || _options$cdnOptions$n === void 0 ? void 0 : _options$cdnOptions$n.site
    }
  }));
};